// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"space_fullWidth__23qUw"};